import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import {
	GetDetailMerchantRequestPayload,
	GetListMerchantRequestPayload,
	UpdateMerchantRequestPayload,
	UpdateStatusMerchantRequestPayload,
	getDetailMerchantRequestAsync,
	getListMerchantRequestAsync,
	setDetailMerchantRequest,
	setListMerchantRequest,
	updateMerchantRequestAsync,
	updateStatusMerchantRequestAsync,
} from "./merchantRequest.slice";
import { message } from "antd";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";

function* getListMerchantRequestSaga(
	action: PayloadAction<GetListMerchantRequestPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/dashboard/merchant-requests", {
				...query,
				skip: query.skip * query.take,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListMerchantRequest.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListMerchantRequest() {
	yield takeLatest(getListMerchantRequestAsync, getListMerchantRequestSaga);
}

function* getDetailMerchantRequestSaga(
	action: PayloadAction<GetDetailMerchantRequestPayload>,
) {
	const { id, callback, language } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/merchant-requests/${id}`, { language });
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		const total = response.data?.data?.totalCars ?? 0;
		callback?.(id, total);
		yield put({ type: setDetailMerchantRequest.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetDetailMerchantRequest() {
	yield takeLatest(getDetailMerchantRequestAsync, getDetailMerchantRequestSaga);
}

function* updateMerchantRequestSaga(
	action: PayloadAction<UpdateMerchantRequestPayload>,
) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(
				`/dashboard/merchant-requests/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateMerchantRequest() {
	yield takeLatest(updateMerchantRequestAsync, updateMerchantRequestSaga);
}

function* updateStatusMerchantRequestSaga(
	action: PayloadAction<UpdateStatusMerchantRequestPayload>,
) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch(
				`/dashboard/merchant-requests/${id}/status`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		message.open({
			key: "updateStatusMerchantRequest",
			type: 'success',
			content: translate("Update successful"),
		});

	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateStatusMerchantRequest() {
	yield takeLatest(updateStatusMerchantRequestAsync, updateStatusMerchantRequestSaga);
}

const merchantRequestSaga = [
	watchGetListMerchantRequest(),
	watchUpdateMerchantRequest(),
	watchGetDetailMerchantRequest(),
	watchUpdateStatusMerchantRequest(),
];

export default merchantRequestSaga;
